import { render, staticRenderFns } from "./tabla.vue?vue&type=template&id=5f1e71da&scoped=true"
import script from "./tabla.js?vue&type=script&lang=js&external"
export * from "./tabla.js?vue&type=script&lang=js&external"
import style0 from "./tabla.scss?vue&type=style&index=0&id=5f1e71da&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1e71da",
  null
  
)

export default component.exports